import { combineReducers } from 'redux';
import user from './modules/user/reducer';

const reducers = combineReducers({ user });

export default reducers;
